module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_4_3_w_1465.71f215d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_4_3_w_1465.jpg
// module id = hcq/
// module chunks = 0